module.exports = __webpack_public_path__ + "static/media/HT_stay_insulator.d9e3c19d.webp";